// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"338696c5","719":"338696c5"}[chunkId] + ".chunk.css";
};